// extracted by mini-css-extract-plugin
export default {"logo":"MadeByBimatter_logo__tDkfa","no_click":"MadeByBimatter_no_click__q1G1H"};